module.exports = __webpack_public_path__ + "static/media/ic_line_selected_inverted.b4e984ae.svg";